/**
 * Subimods Knowledge Hub
 * Expects root: [data-sm-knowledge-hub]
 * Index: assets/sm-knowledge-index.json
 */
(function () {
  'use strict';

  var RESULT_CAP = 40;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function normalize(value) {
    return (value || '')
      .toLowerCase()
      .replace(/[^\w\s+]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function wordsOf(query) {
    return normalize(query).split(' ').filter(Boolean);
  }

  function stripHtml(html) {
    return (html || '').replace(/<[^>]+>/g, ' ');
  }

  function isFinalThoughts(heading) {
    return normalize(heading).indexOf('final thoughts') === 0;
  }

  function isMobileNav() {
    return window.matchMedia('(max-width: 899px)').matches;
  }

  function passageScore(passage, article, words) {
    var heading = normalize(passage.heading);
    var body = normalize(passage.searchText);
    var title = normalize(article.title);
    var haystack = heading + ' ' + body + ' ' + title;
    for (var i = 0; i < words.length; i += 1) {
      if (haystack.indexOf(words[i]) === -1) return 0;
    }
    var score = 1;
    var headingHit = words.every(function (word) { return heading.indexOf(word) !== -1; });
    var titleHit = words.every(function (word) { return title.indexOf(word) !== -1; });
    if (headingHit) score += 5;
    if (titleHit) score += 2;
    if (passage.kind === 'faq') score += 3;
    return score;
  }

  function initRoot(root) {
    if (!root || root.dataset.smKnowledgeReady === 'true') return;
    root.dataset.smKnowledgeReady = 'true';
    document.documentElement.classList.add('sm-knowledge-page');

    var input = root.querySelector('[data-sm-knowledge-search]');
    var clearBtn = root.querySelector('[data-sm-knowledge-clear]');
    var meta = root.querySelector('[data-sm-knowledge-meta]');
    var list = root.querySelector('[data-sm-knowledge-list]');
    var articleNav = root.querySelector('[data-sm-knowledge-articles]');
    var navEmpty = root.querySelector('[data-sm-knowledge-nav-empty]');
    var nav = root.querySelector('[data-sm-knowledge-nav]');

    function syncNav() {
      if (!nav) return;
      if (!isMobileNav()) nav.open = true;
    }

    syncNav();
    window.addEventListener('resize', syncNav);
    if (isMobileNav() && nav) nav.open = false;
    var navCurrent = root.querySelector('[data-sm-knowledge-nav-current]');
    var panelHead = root.querySelector('[data-sm-knowledge-panel-head]');
    var heading = root.querySelector('[data-sm-knowledge-heading]');
    var articleLink = root.querySelector('[data-sm-knowledge-article-link]');
    var emptySearch = root.querySelector('[data-sm-knowledge-empty-search]');
    var emptyNone = root.querySelector('[data-sm-knowledge-empty-none]');
    var emptyError = root.querySelector('[data-sm-knowledge-empty-error]');

    var articles = [];
    var activeHandle = '';
    var requestId = 0;

    function setMeta(text) {
      if (meta) meta.textContent = text || '';
    }

    function showEmpty(which) {
      if (emptySearch) emptySearch.classList.toggle('is-visible', which === 'search');
      if (emptyNone) emptyNone.classList.toggle('is-visible', which === 'none');
      if (emptyError) emptyError.classList.toggle('is-visible', which === 'error');
    }

    function articleUrl(article, anchor) {
      var url = article.url || '#';
      if (!anchor) return url;
      return url.split('#')[0] + '#' + anchor;
    }

    function matchesFor(query) {
      var words = wordsOf(query);
      if (!words.length) return [];
      var hits = [];
      articles.forEach(function (article) {
        article.passages.forEach(function (passage) {
          var score = passageScore(passage, article, words);
          if (score) {
            hits.push({ article: article, passage: passage, score: score });
          }
        });
      });
      hits.sort(function (a, b) {
        var aClosing = isFinalThoughts(a.passage.heading) ? 1 : 0;
        var bClosing = isFinalThoughts(b.passage.heading) ? 1 : 0;
        if (aClosing !== bClosing) return aClosing - bClosing;
        if (b.score !== a.score) return b.score - a.score;
        return a.passage.heading.localeCompare(b.passage.heading);
      });
      return hits;
    }

    function grouped(hits) {
      var groups = [];
      var byHandle = {};
      hits.forEach(function (hit) {
        var handle = hit.article.handle;
        if (!byHandle[handle]) {
          byHandle[handle] = { article: hit.article, hits: [], score: 0 };
          groups.push(byHandle[handle]);
        }
        byHandle[handle].hits.push(hit);
        if (hit.score > byHandle[handle].score) byHandle[handle].score = hit.score;
      });
      groups.sort(function (a, b) {
        if (b.score !== a.score) return b.score - a.score;
        if (b.hits.length !== a.hits.length) return b.hits.length - a.hits.length;
        return a.article.title.localeCompare(b.article.title);
      });
      return groups;
    }

    function renderArticles(groups) {
      if (!articleNav) return;
      articleNav.innerHTML = '';
      var hasQuery = groups.length > 0;
      articleNav.hidden = !hasQuery;
      if (navEmpty) navEmpty.hidden = hasQuery;
      if (!hasQuery) {
        if (navCurrent) navCurrent.textContent = 'Search';
        return;
      }

      function addButton(label, handle, count, pressed) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'sm-support-hub__cat' + (pressed ? ' is-active' : '');
        button.setAttribute('data-sm-knowledge-article', handle);
        button.setAttribute('aria-pressed', pressed ? 'true' : 'false');
        button.innerHTML =
          '<span class="sm-support-hub__cat-icon" aria-hidden="true">' +
            '<svg viewBox="0 0 20 20" fill="none"><path d="M5 3.5h7.5L15.5 6.5V16.5H5V3.5Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><path d="M12.5 3.5V6.5H15.5" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>' +
          '</span>' +
          '<span class="sm-knowledge-hub__article-label"></span>' +
          (count ? '<span class="sm-knowledge-hub__count"></span>' : '');
        button.querySelector('.sm-knowledge-hub__article-label').textContent = label;
        if (count) button.querySelector('.sm-knowledge-hub__count').textContent = String(count);
        button.addEventListener('click', function () {
          activeHandle = handle;
          if (nav && isMobileNav()) nav.open = false;
          render();
        });
        articleNav.appendChild(button);
      }

      addButton('All matches', '', null, !activeHandle);
      groups.forEach(function (group) {
        addButton(group.article.title, group.article.handle, group.hits.length, activeHandle === group.article.handle);
      });
    }

    function renderPassages(hits, showArticle) {
      if (!list) return;
      list.innerHTML = '';
      var visible = hits.slice(0, RESULT_CAP);
      visible.forEach(function (hit) {
        var item = document.createElement('details');
        item.className = 'sm-support-item';
        var summary = document.createElement('summary');
        summary.className = 'sm-support-item__summary';
        var copy = document.createElement('span');
        copy.className = 'sm-knowledge-hub__result-copy';
        var label = document.createElement('span');
        label.className = 'sm-knowledge-hub__result-heading';
        label.textContent = hit.passage.heading;
        copy.appendChild(label);
        if (showArticle) {
          var source = document.createElement('span');
          source.className = 'sm-knowledge-hub__result-article';
          source.textContent = hit.article.title;
          copy.appendChild(source);
        }
        var icon = document.createElement('span');
        icon.className = 'sm-support-item__icon';
        icon.setAttribute('aria-hidden', 'true');
        icon.innerHTML = '<svg viewBox="0 0 16 16" fill="none"><path d="M3.5 6 8 10.5 12.5 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        summary.appendChild(copy);
        summary.appendChild(icon);

        var body = document.createElement('div');
        body.className = 'sm-support-item__body';
        var answer = document.createElement('div');
        answer.className = 'sm-support-item__answer rte';
        answer.innerHTML = hit.passage.html || '';
        var link = document.createElement('a');
        link.className = 'sm-support-link sm-support-link--blue';
        link.href = articleUrl(hit.article, hit.passage.anchor);
        link.innerHTML = '<span>Read in article</span><svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M4 12 12 4M6.5 4H12v5.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        body.appendChild(answer);
        body.appendChild(link);
        item.appendChild(summary);
        item.appendChild(body);
        list.appendChild(item);
      });
    }

    function render() {
      syncNav();
      var query = input ? input.value : '';
      var hits = matchesFor(query);
      var groups = grouped(hits);
      if (activeHandle && !groups.some(function (group) { return group.article.handle === activeHandle; })) {
        activeHandle = '';
      }
      var visibleHits = activeHandle
        ? hits.filter(function (hit) { return hit.article.handle === activeHandle; })
        : hits;
      var activeGroup = groups.filter(function (group) { return group.article.handle === activeHandle; })[0];

      renderArticles(groups);
      renderPassages(visibleHits, !activeHandle);

      if (clearBtn) clearBtn.classList.toggle('is-visible', !!normalize(query));

      if (!normalize(query)) {
        setMeta('');
        showEmpty('search');
        if (panelHead) panelHead.hidden = true;
        if (list) list.innerHTML = '';
        return;
      }

      if (!hits.length) {
        setMeta('No matching sections');
        showEmpty('none');
        if (panelHead) panelHead.hidden = true;
        return;
      }

      showEmpty('');
      var sectionCount = visibleHits.length;
      var articleCount = activeHandle ? 1 : groups.length;
      var metaText = sectionCount + (sectionCount === 1 ? ' section' : ' sections');
      if (!activeHandle) {
        metaText += ' in ' + articleCount + (articleCount === 1 ? ' article' : ' articles');
      }
      if (visibleHits.length > RESULT_CAP) {
        metaText = 'Showing ' + RESULT_CAP + ' of ' + visibleHits.length + ' sections';
      }
      setMeta(metaText);

      if (activeGroup && panelHead && heading && articleLink) {
        panelHead.hidden = false;
        heading.textContent = activeGroup.article.title;
        articleLink.href = articleUrl(activeGroup.article);
        articleLink.hidden = false;
        if (navCurrent) navCurrent.textContent = activeGroup.article.title;
      } else if (panelHead) {
        panelHead.hidden = true;
        if (navCurrent) navCurrent.textContent = 'All matches';
      }
    }

    if (input) {
      input.addEventListener('input', function () {
        var current = ++requestId;
        window.setTimeout(function () {
          if (current !== requestId) return;
          render();
        }, 120);
      });
    }

    if (clearBtn && input) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        activeHandle = '';
        input.focus();
        render();
      });
    }

    var indexUrl = root.getAttribute('data-index-url');
    fetch(indexUrl)
      .then(function (response) {
        if (!response.ok) throw new Error('index');
        return response.json();
      })
      .then(function (data) {
        articles = (data && data.articles) || [];
        articles.forEach(function (article) {
          (article.passages || []).forEach(function (passage) {
            passage.searchText = stripHtml(passage.html);
          });
        });
        render();
      })
      .catch(function () {
        showEmpty('error');
      });
  }

  ready(function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sm-knowledge-hub]'), initRoot);
  });
})();
